export default __webpack_public_path__ + "static/media/approved.b709bf2d.png";